/* eslint-disable import/no-anonymous-default-export */
export default {
  // 屏幕
  cp_air_snow2_screen_type: '4-inch IPS Display',
  cp_air_snow2_screen_size: '254 ppi',
  cp_air_snow2_screen_touch: 'Capacitive touchscreen',
  cp_air_snow2_screen_brightness: 'Auto-brightness',
  cp_air_dany_screen_type: 'OLED',
  cp_air_dany_screen_size: '59.9 × 49.9 mm',
  cp_air_pheasantco2_screen_type: 'Low-power LCD',
  cp_air_pheasantco2_screen_size: '61 × 49 mm',
  cp_air_robb_screen_type: 'E-Ink Screen Version / Screenless Version',
  cp_air_robb_screen_size: 'E-Ink screen size: 36 × 72 mm',

  // 可更换 PM 传感器
  cp_air_title_pm_sensor: 'Replaceable PM Sensor',
  cp_sensor_replaceable: 'Replaceable',

  // 量程
  cp_range_label_temp: 'Temperature: ',
  cp_range_label_humidity: 'Humidity: ',
  cp_range_label_co2: 'CO2: ',
  cp_range_label_pm2510: 'PM2.5/PM10: ',
  cp_range_label_etvoc: 'eTVOC: ',
  cp_range_label_noise: 'Noise: ',
  cp_range_label_light: 'Light level: ',
  cp_range_air_not: 'Do not place this product in environment with humidity higher than 90% for long term use.',

  // snow2 量程
  cp_air_range_snow2_temp_value: '-10 ~ 60°C',
  cp_air_range_snow2_humidity_value: '0 ~ 99%RH (no condensation)',
  cp_air_range_snow2_co2_value: '400 ~ 9999 ppm',
  cp_air_range_snow2_pm2510_value: '0 ~ 999 μg/m³',
  cp_air_range_snow2_etvoc_value: 'VOC Index 0 ~ 500, or 0.005 ~ 9.999 mg/m³',
  cp_air_range_snow2_noise_value: '36 ~ 95 dB',
  // dany 量程
  cp_air_range_dany_temp_value: '0 ~ 40°C',
  cp_air_range_dany_humidity_value: '0 ~ 95%RH (no condensation)',
  cp_air_range_dany_co2_value: '400 ~ 9999 ppm',
  cp_air_range_dany_pm2510_value: '0 ~ 500 μg/m³',
  // pheasant_co2 量程
  cp_air_range_pheasantco2_temp_value: '-20 ~ 50°C',
  cp_air_range_pheasantco2_humidity_value: '0 ~ 99%RH (no condensation)',
  cp_air_range_pheasantco2_co2_value: '400 ~ 9999 ppm',
  // robb 量程
  cp_air_mobile_range_robb_temp_value: 'Screenless version: -10 ~ 60°C, E-Ink screen version: 0 ~ 50°C',
  cp_air_range_robb_temp_value: 'Screenless version: -10 ~ 60°C, E-Ink screen version: 0 ~ 50°C',
  // cp_air_range_robb_temp_value2: '',
  cp_air_range_robb_humidity_value: '0 ~ 99%RH (no condensation)',
  cp_air_range_robb_co2_value: '400 ~ 9999 ppm',
  cp_air_range_robb_pm2510_value: '0 ~ 999 μg/m³',
  cp_air_range_robb_etvoc_value: 'VOC Index 0 ~ 500, or 0.005 ~ 9.999 mg/m³',
  cp_air_range_robb_noise_value: '36 ~ 95 dB',
  cp_air_range_robb_light_value: '0 ~ 83000 lux',

  // 尺寸重量
  cp_air_snow2_weight: '250 g',
  cp_air_snow2_size: '74 × 85 × 104 mm',
  cp_air_dany_weight: '143 g',
  cp_air_dany_size: '63.6 × 46 × 54.6 mm',
  cp_air_pheasantco2_weight: '129 g',
  cp_air_pheasantco2_size: '77 × 77 × 28 mm',
  cp_air_robb_box: 'Main Body',
  cp_air_robb_box_weight: '113 g',
  cp_air_robb_box_size: '86 × 86 × 23 mm',
  cp_air_robb_box_power: 'Wall-Box AC Module / Wall-Box Low-Volt Module',
  cp_air_robb_box_power_weight: '62 g',
  cp_air_robb_box_power_size: '82 × 82 × 33 mm',
  cp_air_robb_box_wall_power: 'Wall-Mounted Low-Volt Module',
  cp_air_robb_box_wall_power_weight: '57 g',
  cp_air_robb_box_wall_power_size: '86 × 86 × 24 mm',

  // 无线通讯
  cp_air_snow2_wireless: 'Wi-Fi 2.4GHz/5GHz',
  cp_air_dany_wireless: 'Wi-Fi 2.4GHz, Bluetooth 5.0',
  cp_air_pheasantco2_wireless: 'Wi-Fi 2.4GHz or NB-IoT or LoRa',
  cp_air_mobile_pheasantco2_wireless: 'Wi-Fi 2.4GHz or\nNB-IoT or LoRa',
  cp_air_robb_wireless: 'Wi-Fi 2.4GHz or NB-IoT or LoRa',

  // 电池
  cp_air_snow2_power_up: 'USB-C charging port',
  cp_air_snow2_power_up_desc: 'Rechargeable lithium battery',
  cp_air_dany_power_up: 'USB-C charging port',
  cp_air_dany_power_up_desc: 'Rechargeable lithium battery',
  cp_air_pheasantco2_power_up: 'USB-C charging port',
  cp_air_pheasantco2_power_up_desc: 'High-capacity rechargeable lithium battery',
  cp_air_robb_power_up1: 'Wall-Box AC Module',
  cp_air_robb_power_up_desc1: '100–240V AC',
  cp_air_robb_power_up2: 'Wall-Box Low-Volt Module',
  cp_air_robb_power_up_desc2: '9-24V AC or 9–30V DC',
  cp_air_robb_power_up3: 'Wall-Mounted Low-Volt Module',
  cp_air_robb_power_up_desc3: '9–24V AC / 9–30V DC / USB-C (5V⎓1A)',
  cp_air_mobile_robb_power_up_desc3: '9-24V AC or 9–30V DC or USB-C (5V⎓1A)',

  // mounting
  cp_air_snow2_mounting: 'Desktop placement',
  cp_air_dany_mounting: 'Desktop placement',
  cp_air_pheasantco2_mounting: 'Wall mode',
  cp_air_robb_mounting: 'Wall-mounted',

  // more features
  cp_more_features: 'More Features',
  cp_air_snow2_more_features1: 'Weather*',
  cp_air_snow2_more_features2: 'Air quality index*',
  cp_air_snow2_more_features3: 'UV index*',
  cp_air_snow2_more_features4: 'No-driving plates*',
  cp_air_snow2_more_features5: 'Clock · Alarm*',
  cp_air_snow2_more_note: 'Weather, AQI, UV and no-driving plates are only available in some cities.',
  cp_air_pheasantco2_more_features: 'Buzzer',
};